import { NavLink } from "react-router-dom";
import { publicUser } from "../../../../../../globals/route-names";
import SectionSideAdvert from "./section-side-advert";
import JobZImage from "../../../../../common/jobz-img";

function SectionJobsSidebar2({ _config, job = {}, locked = false }) {
    const privateMode = Boolean(job.mask_contact_details);
    const lockedText = <span><i className="fa fa-lock" /> Login to view</span>;
    return (
        <>
            <div className="side-bar mb-4">
                <div className="twm-s-info2-wrap mb-5">
                    <div className="twm-s-info2">
                        <h4 className="section-head-small mb-4">Job Information</h4>
                        <ul className="twm-job-hilites">
                            <li>
                                <i className="fas fa-calendar-alt" />
                                <span className="twm-title">Date Posted</span>
                            </li>
                            <li>
                                <i className="fas fa-eye" />
                                <span className="twm-title">{job.view_count || 0} Views</span>
                            </li>
                            <li>
                                <i className="fas fa-file-signature" />
                                <span className="twm-title">{job.application_count || 0} Applicants</span>
                            </li>
                        </ul>
                        <ul className="twm-job-hilites2">
                            <li>
                                <div className="twm-s-info-inner">
                                    <i className="fas fa-calendar-alt" />
                                    <span className="twm-title">Date Posted</span>
                                    <div className="twm-s-info-discription">{job.created_at ? new Date(job.created_at).toLocaleDateString() : "Recently"}</div>
                                </div>
                            </li>
                            <li>
                                <div className="twm-s-info-inner">
                                    <i className="fas fa-map-marker-alt" />
                                    <span className="twm-title">Location</span>
                                    <div className="twm-s-info-discription">{locked ? lockedText : job.location || "Location not provided"}</div>
                                </div>
                            </li>
                            <li>
                                <div className="twm-s-info-inner">
                                    <i className="fas fa-user-tie" />
                                    <span className="twm-title">Job Title</span>
                                    <div className="twm-s-info-discription">{job.title || "Job title"}</div>
                                </div>
                            </li>
                            <li>
                                <div className="twm-s-info-inner">
                                    <i className="fas fa-clock" />
                                    <span className="twm-title">Experience</span>
                                    <div className="twm-s-info-discription">{locked ? lockedText : job.experience || "As required"}</div>
                                </div>
                            </li>
                            <li>
                                <div className="twm-s-info-inner">
                                    <i className="fas fa-suitcase" />
                                    <span className="twm-title">Qualification</span>
                                    <div className="twm-s-info-discription">{locked ? lockedText : job.qualification || "As per role"}</div>
                                </div>
                            </li>
                            <li>
                                <div className="twm-s-info-inner">
                                    <i className="fas fa-venus-mars" />
                                    <span className="twm-title">Gender</span>
                                    <div className="twm-s-info-discription">Both</div>
                                </div>
                            </li>
                            <li>
                                <div className="twm-s-info-inner">
                                    <i className="fas fa-money-bill-wave" />
                                    <span className="twm-title">Offered Salary</span>
                                    <div className="twm-s-info-discription">{locked ? lockedText : salary(job)}</div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="widget tw-sidebar-tags-wrap">
                    <h4 className="section-head-small mb-4">Job Skills</h4>
                    <div className="tagcloud">
                        <a href="/job-list?skill=Html">Html</a>
                        <a href="/job-list?skill=Python">Python</a>
                        <a href="/job-list?skill=WordPress">WordPress</a>
                        <a href="/job-list?skill=JavaScript">JavaScript</a>
                        <a href="/job-list?skill=Figma">Figma</a>
                        <a href="/job-list?skill=Angular">Angular</a>
                        <a href="/job-list?skill=Reactjs">Reactjs</a>
                        <a href="/job-list?skill=Drupal">Drupal</a>
                        <a href="/job-list?skill=Joomla">Joomla</a>
                    </div>
                </div>
            </div>

            {
                _config.showJobInfo &&
                <div className="twm-s-info3-wrap mb-5">
                    <div className="twm-s-info3">
                        <div className="twm-s-info-logo-section">
                            <div className="twm-media">
                                <JobZImage src={job.company_logo_url || job.job_image_url || "images/jobs-company/pic1.jpg"} alt={job.company_name || "Company"} />
                            </div>
                            <h4 className="twm-title">{job.company_name || "Company"}</h4>
                        </div>
                        <ul>
                            <li>
                                <div className="twm-s-info-inner">
                                    <i className="fas fa-building" />
                                    <span className="twm-title">Shared Company Name</span>
                                    <div className="twm-s-info-discription">{job.company_name || "Company"}</div>
                                </div>
                            </li>
                            <li>
                                <div className="twm-s-info-inner">
                                    <i className="fas fa-user-tie" />
                                    <span className="twm-title">Employer Name</span>
                                    <div className="twm-s-info-discription">{locked ? lockedText : job.employer_name || "Employer"}</div>
                                </div>
                            </li>
                            <li>
                                <div className="twm-s-info-inner">
                                    <i className="fas fa-mobile-alt" />
                                    <span className="twm-title">Employer Phone</span>
                                    <div className="twm-s-info-discription">{locked ? lockedText : displayPhone(job.employer_phone) || "Not provided"}</div>
                                </div>
                            </li>
                            <li>
                                <div className="twm-s-info-inner">
                                    <i className="fas fa-map-marker-alt" />
                                    <span className="twm-title">Employer Address</span>
                                    <div className="twm-s-info-discription">{locked ? lockedText : displayContact(job.employer_address, privateMode) || "Not provided"}</div>
                                </div>
                            </li>
                            <li>
                                <div className="twm-s-info-inner">
                                    <i className="fas fa-at" />
                                    <span className="twm-title">Job Support Email</span>
                                    <div className="twm-s-info-discription">{locked ? lockedText : displayEmail(job.support_email, privateMode) || "Not provided"}</div>
                                </div>
                            </li>
                            <li>
                                <div className="twm-s-info-inner">
                                    <i className="fas fa-headset" />
                                    <span className="twm-title">Job Support Phone</span>
                                    <div className="twm-s-info-discription">{locked ? lockedText : displayPhone(job.support_phone) || "Not provided"}</div>
                                </div>
                            </li>
                        </ul>
                        <NavLink to={publicUser.pages.ABOUT} className=" site-button">Vew Profile</NavLink>
                    </div>
                </div>
            }
            
            <SectionSideAdvert />
        </>
    )
}

function displayEmail(value, privateMode) {
    if (!value || !privateMode) return value;
    const [name, domain] = value.split("@");
    return `${maskMiddle(name)}@${domain || "xxx"}`;
}

function displayContact(value, privateMode) {
    if (!value || !privateMode) return value;
    return maskMiddle(String(value));
}

function displayPhone(value) {
    if (!value) return "";
    const str = String(value).trim();
    if (str.length <= 4) return str + "xxxx";
    return str.slice(0, 4) + "x".repeat(Math.max(4, str.length - 4));
}

function salary(job) {
    if (job.salary_min && job.salary_max) return `${formatInr(job.salary_min)} - ${formatInr(job.salary_max)} / ${job.salary_period || "Month"}`;
    if (job.salary_min) return `${formatInr(job.salary_min)} / ${job.salary_period || "Month"}`;
    return "Salary disclosed after login";
}

function formatInr(value) {
    return `₹${Number(value || 0).toLocaleString("en-IN")}`;
}

function maskMiddle(value) {
    if (value.length <= 4) return "xxx";
    return `${value.slice(0, 2)}xxx${value.slice(-2)}`;
}

export default SectionJobsSidebar2;
